export const companyRankingReducer = (state = {}) => state;
